import React from 'react';
import './styles/app-theme.css';
import { Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import GameHeader from './components/GameHeader'
// Page Imports
import RegisterPage from './pages/RegisterPage';
import RegisterErrorPage from './pages/RegisterErrorPage';
import UpdatePage from './pages/UpdatePage';
import LoginErrorPage from './pages/LoginErrorPage';
import GameLoginPage from './pages/GameLoginPage';
import LaunchGamePage from './pages/LaunchGamePage';
import AlphaLandingPage from './pages/AlphaLandingPage';

const App: React.FC = () => {
  return (
    <>
      <GameHeader />
      <Routes>
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register-error" element={<RegisterErrorPage />} />
        <Route path="/update" element={<UpdatePage />} /> 
        <Route path="/loginerror" element={<LoginErrorPage />} />
        <Route path="/login" element={<GameLoginPage />} />
        <Route path="/launchgame" element={<LaunchGamePage />} />
        <Route path="/" element={<AlphaLandingPage />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;